import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import {CommonModule} from '@angular/common';
import {MatButtonModule} from '@angular/material/button';
import {MatTooltipModule} from '@angular/material/tooltip';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';

export interface PublishConfirmationData {
  mapName: string;
  published: boolean; // true = published, false = unpublished
}

@Component({
  selector: 'app-publish-confirmation-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatTooltipModule, TranslatePipe],
  template: `
    <div class="w-100 d-flex justify-content-between align-items-center dialog-header">
      <h2 class="align-items-center d-flex m-0 p-0">
        <span class="material-symbols-rounded me-2">campaign</span>
        {{ data.published ? ('MISC_DIALOGS.PUBLISH_CONFIRM.TITLE_PUBLISHED' | translate) : ('MISC_DIALOGS.PUBLISH_CONFIRM.TITLE_UNPUBLISHED' | translate) }}
      </h2>
      <span class="icon-smap-action-close close-button" mat-dialog-close
            [matTooltip]="'PUBLISH_STORE.CLOSE_TOOLTIP' | translate"></span>
    </div>

    <div mat-dialog-content class="p-3 px-4">
      <p class="m-0">
        {{ getMessage() }}
      </p>
    </div>

    <div mat-dialog-actions class="d-flex justify-content-center">
      <button class="dialog-action-btn dialog-action-btn-primary" mat-dialog-close cdkFocusInitial>
        {{ 'AI_ERROR.OK' | translate }}
      </button>
    </div>
  `,
  styles: []
})
export class PublishConfirmationDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<PublishConfirmationDialogComponent>,
    private translate: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data: PublishConfirmationData
  ) {}

  getMessage(): string {
    if (this.data.published) {
      return this.translate.instant('MISC_DIALOGS.PUBLISH_CONFIRM.MESSAGE_PUBLISHED', {name: this.data.mapName});
    } else {
      return this.translate.instant('MISC_DIALOGS.PUBLISH_CONFIRM.MESSAGE_UNPUBLISHED', {name: this.data.mapName});
    }
  }
}
